import React from 'react';
import "../gestpagamentos.css";
import { AreaChart,PieChart,Pie,  Sector, Cell,Tooltip,CartesianGrid,XAxis,YAxis, Area,ResponsiveContainer} from 'recharts';
import parseISO from 'date-fns/parseISO';
import subDays from 'date-fns/subDays';
import format from 'date-fns/format';

function GestPagamentos() {
    const COLORS = ['#053f40', '#ca2210', '#ffa500'];
    const data=[];
    const datas=[];
    for(let num=30;num>=0;num--){
        data.push({
            date:subDays(new Date(),num).toISOString().substr(0,10),
            value:1+Math.random(),
            mpesa:1-Math.random(),
            emola:0.5*Math.random(),
            paypal:0.75*Math.random(),
            ponto:0.45*Math.random(),
            visa:1.005*Math.random(),
          })
    }
    for(let num=2;num>=0;num--){
        datas.push({
            date:subDays(new Date(),num).toISOString().substr(0,10),
            value:1+Math.random(),
            mpesa:1-Math.random(),
            emola:0.5*Math.random(),

        })
    }
  return <div id="pagamentos">
      <ResponsiveContainer  width="100%" height={200}  className="casa">
      <PieChart width={400} height={400}>
      <Pie
            data={datas}
            cx={120}
            cy={90}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
            
          </Pie>
          <Pie
            data={datas}
            cx={420}
            cy={90}
            startAngle={180}
            endAngle={0}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip/>
            </PieChart>
          
      </ResponsiveContainer>
      <ResponsiveContainer width="100%" height={300}  className="casa">
      <AreaChart data={data} >
        <defs>
            <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#053f40' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#053f40' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colors" x1="0" y1="0" x2="0" y2="1">

                <stop offset="0%" stopColor='#ca2210' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ca2210' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#ffa500' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ffa500' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsaa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#ca2210' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#ca2210' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsaaa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#00FF00' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#00FF00' stopOpacity={0.05}></stop>
            </linearGradient>
            <linearGradient id="colorsaaaa" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor='#00FFFF' stopOpacity={0.4}></stop>
                <stop offset="75%" stopColor='#00FFFF' stopOpacity={0.05}></stop>
            </linearGradient>
        
        </defs>
        <Area dataKey="value" stroke="#053f40" fill="url(#color)"/>
        <Area dataKey="mpesa" stroke="#ca2210" fill="url(#colors)"/>
        <Area dataKey="emola" stroke="#ffa500" fill="url(#colorsa)"/>
        <Area dataKey="paypall" stroke="#ca2210" fill="url(#colorsaa)"/>
        <Area dataKey="ponto" stroke="#00FF00" fill="url(#colorsaaa)"/>
        <Area dataKey="visa" stroke="#00ffff" fill="url(#colorsaaaa)"/>
      
        <XAxis dataKey="date"
        axisLine={false}
        tickLine={false}
        tickFormatter={str=>{
            const date=parseISO(str);
            if(date.getDate() %7==0){
                return  format(date,"MMM, d")
            }
            return ""
        }}/>
        <YAxis dataKey="value"
        axisLine={false}
        tickLine={false}
        tickCount={8}
        tickFormatter={number=>`${number.toFixed(2)}mil`}/>
        <Tooltip/>
        <CartesianGrid opacity={0.1} vertical={false}/>
      </AreaChart>
  </ResponsiveContainer>

  </div>;
}

export default GestPagamentos;
